<template>
    <div class="rules-box">
        <el-dialog title :visible.sync="pop_show" class="rules-pop" v-if="pop_show" :close-on-click-modal="false">
            <div class="close" @click="closePop()"></div>
            <div class="title">零玖电竞用户行为条例</div>
            <base-divider></base-divider>
            <div class="rule-content">
                <div class="inst-word">
                    <p class="tite">1.目的</p>
                    <p
                        class="height bottom"
                    >我们的目标是为所有玩家建立一个有趣且公平的游戏环境，因此，对于给其他玩家的游戏体验造成负面影响，或违反本条款的玩家将给予账号处罚。如果您发现有玩家在零玖电竞进行游戏时违反了规范，请向我们进行举报并协助我们进行调查。对存在违规行为的账号执行处罚的同时，我们会向对应的账号邮箱中发送一封通知邮件，并对处理原因及具体处罚情况进行详述。</p>
                    <p class="tite">2.禁止以下游戏内不当行为</p>
                    <p class="height">2.1 使用不适当言辞、名称或标记垃圾信息意图扰乱聊天，轻度骚扰其他玩家，诋毁、污蔑其他玩家。</p>
                    <p class="height">2.2 使用猥亵或粗俗言辞、名称或标记；宣传违禁药物、赌博、色情信息；散布非官方认可的公司、网站或服务的广告；玩家创建的内容包含第三方的知识产权或其他人身性、财产性内容且未取得许可。</p>
                    <p
                        class="height"
                    >2.3 发布以下言论或内容：（1）反对中华人民共和国宪法所确定的基本原则的；（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；（3）损害国家荣誉和利益的；（4）煽动民族仇恨、民族歧视，破坏民族团结的；（5）破坏国家宗教政策，宣扬邪教和封建迷信的；（6）散布谣言，扰乱社会秩序，破坏社会稳定的；（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；（8）侮辱或者诽谤他人，侵害他人合法权益的；（9）发布违反社会公德、违背公序良俗的内容的；（10）宣扬恐怖主义、极端主义的；（11）发布扰乱经济秩序或社会秩序的虚假信息的；（11）发布侵害他人名誉、隐私、知识产权的；（12）宣扬、教唆使用外挂、私服以及木马的相关内容的；（13）发布任何经零玖电竞合理判断为不妥当或者零玖电竞未认可的软件、文件等在内的主页地址或者链接的；（14）含有中华人民共和国法律、行政法规禁止的其他内容的。</p>
                    <p
                        class="height"
                    >2.4 涉及性暗示、猥亵、侮辱或攻击其他玩家，散播其他玩家个人信息、宗教信仰或隐私，对他人造成现实生活威胁，散布他人个人信息（姓名、住址和电话等）或隐私，冒充游戏管理员（GM）或系统发布虚假信息或实施欺诈行为（包括通过虚假承诺、虚构事实、隐瞒真相、故意误导、冒充他人、故意混淆等方式，骗取他人的游戏虚拟物品或其它财物等），非法盗取他人账号/个人信息（包括但不限于盗取用户账号、游戏数据、玩家个人资料、协助盗号者操作及转移游戏虚拟物品等）。</p>
                    <p
                        class="height"
                    >2.5 干扰零玖电竞正常地提供游戏和服务，包括但不限于：（1）攻击、侵入零玖电竞的网站服务器，或集中时间段内以超出正常用户登录需求的高频率登录或尝试登录服务器从而使网站服务器过载；（2）破解、修改零玖电竞游戏程序；（3）攻击、侵入零玖电竞游戏的服务器/游戏服务器端程序或使游戏服务器过载；（4）制作、发布、传播、使用任何形式的妨碍游戏公平性的辅助工具或程序（包括但不限于“外挂”, “外挂”是指独立于游戏软件之外的，能够在游戏运行的同时影响游戏操作的所有程序，包括但不限于模拟用户操作、改变操作环境、修改数据等一切类型）；（5）利用程序的漏洞和错误（Bug）破坏游戏的正常进行或传播该漏洞或错误（Bug）；（6）不合理地干扰或阻碍他人使用零玖电竞游戏和服务；（7）通过异常或者非法的方式使用零玖电竞游戏（包括但不限于利用零玖电竞游戏登录游戏私服）；（8）使用异常的方法登录游戏（包括但不限于使用非零玖电竞开发、授权或认可的第三方软件、系统登录游戏）、使用网络加速器等外挂软件或机器人程序等恶意破坏服务设施、扰乱正常服务秩序的行为；（9）修改、翻译、注释、整理、汇编、演绎零玖电竞游戏；（10）实施导致游戏数据异常的行为（包括利用Bug或非正常方式篡改游戏内数据、游戏内的排名；不以正常的游戏娱乐互动需要为目的进行交易；以转移游戏虚拟物品或提升特定游戏角色实力为目的的非正常交易行为等）；（11）实施谋取不当利益的行为（包括但不限于注册多个用户账号和/或游戏角色ID，以营利为目的进行游戏行为；从事游戏内单一或系列产出玩法，将获得的虚拟物品出售获利；利用不同服务器的虚拟物品价值差异，在不同服务器买卖虚拟物品获利；充当游戏账号、虚拟物品交易中介收取费用获利；在非零玖电竞提供或认可的交易平台上交易用户账号或虚拟物品获利；通过非零玖电竞提供的支付充值渠道兑换游戏代币；将游戏内获得的虚拟物品用于出售获利而不注重本身角色实力的提升，角色多个技能、资源、道具水平与角色等级相差较大的；利用游戏行为和游戏内容组织或参与赌博、实施或参与实施盗窃他人财产或虚拟物品等涉嫌违法犯罪行为等任何不以正常的游戏娱乐互动需要为目的的游戏内牟利行为）；（12）利用零玖电竞游戏或者服务可能存在的技术缺陷或漏洞而以各种形式为自己及他人牟利（包括但不限于复制游戏虚拟物品等）或者从事其他不正当行为等。</p>
                    <p class="height">2.6 其他以任何形式使用零玖电竞下服务损害零玖电竞的品牌、形象、声誉或商业利益的行为。</p>
                    <p class="height">2.7 除以上不当行为外，我们保有对任何上述所列不当行为之外的违规行为采取处理的权力。</p>
                    <p class="height bottom">
                        2.8
                        <span>用户同意以零玖电竞游戏程序中的数据作为判断用户是否有实施不当行为的依据。</span>
                    </p>
                    <p class="tite">3.账号处罚</p>
                    <p
                        class="height"
                    >3.1 账号处罚的主要目的是确保所有玩家可以发挥自己的实力并尽情享受公平的游戏环境，当某些玩家的行为影响到了其他玩家的正常游戏乃至游戏本身的时候，我们有权针对这些行为进行约束和惩处，以确保整体玩家拥有良好的游戏服务质量。但真正的秩序，应源于每个人的习惯。零玖电竞运营团队真诚希望能有那样一天——我们不必再用处罚去约束大家的行为。</p>
                    <p
                        class="height"
                    >3.2 利用零玖电竞下服务系统实施任何游戏内不当行为，零玖电竞有权对用户使用零玖电竞下服务的情况进行审查和监督，如用户在使用网络服务时违反任何上述规定，零玖电竞或其授权的人有权要求用户改正或直接采取一切必要的措施（包括账号处罚措施）以减轻用户不当行为造成的影响。本项规定的不当行为的危害程度并非是对账号处罚的唯一衡量标准，零玖电竞运营团队保留根据具体问题采取合理措施的权利。</p>
                    <p class="height bottom">3.3 我们视玩家的生命安全和健康为第一考虑，并无法容忍游戏内出现现实生活威胁或散播他人隐私。当发生现实威胁他人安全或健康、散播他人隐私时，我们采用最严厉的处罚并可能采取联系当地执法部门确保玩家生命安全和健康。</p>
                    <p class="tite">4.账号处罚细则以及详细诠释</p>
                    <p class="height">处罚的目的是为广大玩家营造一个良好的游戏环境，也希望所有的玩家和我们一起努力，让我们的线上世界变得更加美好。</p>
                    <p class="height">4.1 禁言：为了维护线上社交环境，我们将对影响他人的不当言行发布者采取禁言处理，该处罚仅针对发言功能进行一段时间的限制。</p>
                    <p class="height">4.2 强制离线：我们有权对情节轻微的不当行为给予警告，在警告的基础上，如果情节严重或者对不听警告的玩家，我们可能会对其进行强制离线操作，在强制离线以后，玩家是可以重新登录的。</p>
                    <p class="height">4.3 随机改名：如果发现玩家设定的名称（包括但不限于角色名、游戏昵称、聊天室等）违反了命名规则，系统将随机更改名称。</p>
                    <p class="height">4.4 禁排：如果玩家账号有多次不当言行，消极游戏的行为，违反游戏规则，我们会视情况对违规的游戏账号进行禁排的处罚，在禁排期间该账号可以登录零玖电竞，但无法加入该游戏。</p>
                    <p class="height">4.5 收回牟利数据：如果玩家通过游戏BUG、外挂、代练、对刷等方式，为自己或他人牟取非正当游戏利益，严重影响游戏平衡及环境时，我们将根据情况对该账号的牟利数据进行取消或删除等处理。</p>
                    <p class="height">4.6 账号保护性锁定：当系统检测到玩家的账号存在异常登录时，该账号将被即时锁定以保护账号安全，玩家可以通过验证账号信息为账号解除锁定。</p>
                    <p class="height">4.7 暂时冻结：属于较为严重的处罚，如果玩家存在违反游戏规则，情节严重但未过分违反游戏规则的行为时，我们将根据情节严重程度给予暂时性冻结账号处罚。在冻结期内，账号将暂时失去游戏登录权限。</p>
                    <p class="height">4.8 永久冻结：如果玩家过分的违反游戏规则，或者对游戏环境、其他玩家或者游戏本身造成严重影响，我们将永久停止该账号的使用权，永久冻结是对账号最高级别的处罚，账号将永久失去游戏登录权限。</p>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: 'base-rules',
    props: {},
    created() {},
    data() {
        return {
            pop_show: false,
        }
    },
    methods: {
        // emitter: function (user_id) {
        //     console.log(user_id);
        //     this.$emit('click', user_id)
        // },
        openPop() {
            this.pop_show = true
        },
        closePop() {
            this.pop_show = false
        },
    },
}
</script>
<style  lang="scss">
.rules-pop {
    .el-dialog {
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
        margin-top: 0 !important;
        background: transparent !important;
        border-radius: 0;
        box-shadow: none !important;
        -webkit-box-shadow: none !important;

        .el-form {
            padding-right: 80px;
        }

        .el-dialog__header {
            padding: 0;
            margin: 0;
            // display: none;
            .el-dialog__title {
                font-size: 16px;
            }
            .el-dialog__headerbtn .el-dialog__close {
                font-size: 16px !important;
            }
        }
        .el-dialog__body {
            padding: 0;
            margin: 0;
            box-shadow: none;
            -webkit-box-shadow: none;
            width: 100%;
            height: 100%;
        }

        .el-dialog__footer {
            padding: 0;
            margin: 0;
        }
    }
}
</style>
<style lang="scss" scoped>
.rules-box {
    .rules-pop {
        width: 6.24rem;
        height: 7.84rem;
        background: #ffffff;
        border-radius: 0.3rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        .close {
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            width: 0.56rem;
            height: 0.56rem;
            background: url(~@/assets/img/close.png) 0 0 no-repeat;
            background-size: 100% auto;
            &:hover {
                cursor: pointer;
                background-position-y: -0.56rem;
            }
        }
        .title {
            width: 100%;
            font-size: 0.4rem;
            text-align: center;
            height: 1.2rem;
            font-weight: bold;
            line-height: 1.25rem;
            color: #c39b5e;
        }
        .rule-content {
            width: 100%;
            height: 6.2rem;
            overflow-x: hidden;
            position: relative;
        }
        .inst-word {
            width: 100%;
            height: auto;
            padding: 0 .2rem 0 .3rem;
            position: absolute;
            top: 0;
            left: 0;
            .tite {
                color: #c39b5e;
                font-size: 0.28rem;
                font-weight: bold;
                padding: 0.15rem 0;
            }
            .height {
                color: #4a4a4a;
                line-height: 0.34rem;
                font-size: 0.22rem;
                font-weight: normal;
                margin-bottom: 0.08rem;
                span {
                    font-weight: bold;
                }
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/BaseRules.vue